import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { loadLocal } from '../../helpers/helpers';
import { Performer, tableFilterTypes } from 'src/app/store/performers.era';
import { performerTableReselector, performerColumnsReselector } from 'src/app/store/reselectors/performers.reselector';
import { performerTableColumnsById } from 'src/app/helpers/table-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { addAPerformer, chooseOrAddEntityTypes, ChooseOrAddTypesData, importTableData, saveTable } from './performerSharedFunctions';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { JoiEvent, Label, LabelObject } from 'globals/store/events.data';
import { performerTableColumns, PerformerTableData } from 'src/app/helpers/table-column-types';
import { TableColumn, TableMenuItem } from 'src/app/helpers/table.data';
import { ManagePerformerComponent, ManagePerformerData } from '../manage/manage-performer.component';
import { NestedTableComponent } from './../../components/nested-table/nested-table.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { addLabelsToMany, removeLabelsFromMany } from '../../helpers/label-helpers';
import { LabelUpdateFunctionParams } from '../../components/label-marker/label-maker.dialog.component';
import { PerformersService } from '../../services/performers.service';
import { EntitySubTable, performerSubTableTypes } from 'globals/store/entity.data';
import { performerListReselector } from '../../store/reselectors/entity.decircular.reselector';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { CustomQuestionAnswersComponent } from 'src/app/components/entities/custom-questions-answers.component';
import { JoiNavWrapper } from 'src/app/components/wrappers/joi-nav-wrapper.component';
import { subTableNames } from 'globals/store/entity.data';
import { listDifference, listUnion } from 'globals/helpers/helpers';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { TitleCasePipe, CommonModule, DatePipe } from '@angular/common';

@Component({
    selector: 'performers-table',
    template: `
<top-menu></top-menu>
<mobile-menu></mobile-menu>
<joi-nav-wrapper 
  class="icon-tabs"
  [simple]="true"
  [menuItems]="subTables"
  [menuMap]="subTableNames"
  [selectedId]="subTable" 
  (selectItem)="subTable = $event"
></joi-nav-wrapper>
<custom-question-answers *ngIf="subTable === 'responses'" [entityType]="'performer'"></custom-question-answers>
<command-menu
  *ngIf="subTable !== 'responses'"
  [filterPage]="filterPage"
  [filterType]="filterType"
  [columnType]="performerSubTableTypes[subTable]"
  [editColumnsTitle]="('Edit ' + subTableNames[subTable] + ' Columns') | titlecase"
  [filterText]="'Filter performers'"
  [showDottedMenu]="true"
  [showExport]="true"
  [showImport]="true"
  [canEditColumns]="true"
  [addItemText]="!event || event.is_readonly ? '' : '+ ADD A PERFORMER'"
  (addItem)="addAPerformer($event)"
  (onExport)="saveTable()"
  (onImport)="importTableData()"
></command-menu>
<nested-table
  *ngIf="columnData && subTable !== 'responses'"
  [filtersId]="filterPage"
  [items]="performerData"
  [condensedView]="condensed"
  [columns]="columnData[subTable]"
  [readOnly]="!event || event.is_readonly"
  [columnsById]="columnsById"
  [menuItems]="menuItems"
  [menuDisabled]="busy"
  [defaultSelectedColumnId]="performerTableColumns.name"
  [emptyMessage]="'No performers in this event'"
  [noResultsMessage]="'All performers have been filtered out'"
  [hadItemsBeforeFiltering]="!!fullPerformerList.length"
  (updatedSelectedIds)="selectIds($event)"
  (selectItem)="managePerformer($event)"
></nested-table>
<loader-pane-fragment [trace]="traceNames.viewPerformers"></loader-pane-fragment>
`,
    styleUrls: ['../../page.scss'],
    providers: [DatePipe],
    standalone: true,
    imports: [LoaderPaneFragmentComponent, TitleCasePipe, CommonModule, CommandMenuComponent, TopMenuComponent, MobileMenuComponent, CustomQuestionAnswersComponent, JoiNavWrapper, NestedTableComponent],
})
export class PerformersTableComponent extends Wrapper<PerformersTableComponent>  {
  filterPage = filterPageTypes.performersTable
  traceNames = traceNames
  subTableNames = subTableNames
  filterType = tableFilterTypes.PerformersTable
  performerTableColumns = performerTableColumns
  columnData: { [t in EntitySubTable]: TableColumn[] }
  columnsById: { [id: string]: TableColumn } = performerTableColumnsById
  condensed: boolean
  event: JoiEvent
  performerData: PerformerTableData[]
  performerTableRowsById: { [id:string]: PerformerTableData } = {}
  menuItems: TableMenuItem[] = []
  fullPerformerList: Performer[]
  selectedIds: string[] 
  performer_labels: LabelObject = {}
  busy = false
  subTable: EntitySubTable = 'contactDetails'
  subTables: EntitySubTable[] = ['contactDetails', 'publish', 'logistics', 'myView', 'responses' ]
  performerSubTableTypes = performerSubTableTypes

  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<PerformerTableData>


  saveTable() {
    saveTable('performer' ,`${this.event.title} performers table`, this.dialog, this.nestedTable)
  }
  importTableData(){
    importTableData('performer', this.dialog, this.performerService.addMultiplePerformers.bind(this.performerService))
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    // this.selectCallback(performerClipboardTableReselector, null, console.log)

    this.uiService.changePageTitle("Performers", true)
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select(performerListReselector), 'fullPerformerList')
    this.subProp(this.store.select('events', 'labelMaps', 'performer_labels'), 'performer_labels')
    this.subCallback(this.store.select(performerTableReselector), data => {
      if (!data) {
        this.performerData = [] // for when the last is deleted
        return
      }
      const { performerTableData, performerTableRowsById } = data
      this.performerData = performerTableData
      this.performerTableRowsById = performerTableRowsById
      // console.log({ performerTableRowsById, performerTableData })
    })
    this.subProp(this.store.select(performerColumnsReselector), 'columnData')

    this.loadCondensed()
    this.subCallback(this.store.select('filters', 'toggleFilters', this.filterPage, 'condensed'), _ => this.loadCondensed())
  }

  selectIds(ids: Set<string>) {
    this.selectedIds = Array.from(ids)
    // console.log(this.selectedTaskIds)
    setTimeout(() => this.buildMenu(), 0)
  }

  private get selectedPerformers(): Performer[] {
    return (this.selectedIds || []).map(id => this.performerTableRowsById[id].performer)
  }

  async addToClipboard() {
    this.busy = true
    await this.performerService.templatePerformers(this.selectedPerformers)
    this.busy = false
    const n = this.selectedPerformers.length
    this.nestedTable.setMessage(`Templates for ${n} performer${n > 1 ? 's' : ''} added to the clipboard.`)
    this.nestedTable.unselectAll()
  }

  buildMenu() {
    const performers = this.selectedPerformers
    const n = performers.length
    this.menuItems = []
    this.menuItems.push({ title: 'Add labels', method: this.addLabels.bind(this) })
    if (performers.some(p => p.labels?.length)) this.menuItems.push({ title: 'Remove labels', method: this.removeLabels.bind(this) })
    this.menuItems.push({ title: 'Delete', method: this.deletePerformers.bind(this) }) 
    // this.menuItems.push({ title: 'Add to clipboard', method: this.addToClipboard.bind(this) })
    // this.menuItems.push({ title: 'Duplicate', method: this.duplicatePerformers.bind(this) })
    this.menuItems.push({ title: 'Change type', method: this.changePerformerType.bind(this) })
  }

  public async updateLabelTemplate(labels: Label[]) {
    labels.forEach(label => this.performer_labels[label.id] = label) // need to overwrite the old values here to both maintain order and propagate changes without losing filtered out template labels
    await this.eventService.updateEvent(this.eventService.eventId, { performer_labels: Object.values(this.performer_labels) })
  }

  public async addLabelsUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsChanged) this.updateLabelTemplate(labelTemplate)

    if (!labelsToggled) return
    const performers = this.selectedPerformers
      .filter(p => !p.labels || labels.some(label => !p.labels.includes(label)))
      .map(p => ({...p, labels: listUnion(p.labels, labels) }))
    
    await this.performerService.updatePerformers(performers)
    this.buildMenu()
  }

  public async removeLabelsUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsChanged) this.updateLabelTemplate(labelTemplate)

    if (!labelsToggled) return
    const filteredLabels = labelTemplate.map(l => l.id).filter(id => !labels.includes(id))
    if (filteredLabels.length === 0) return

    const performers = this.selectedPerformers
      .filter(p => p.labels && p.labels.some(label => filteredLabels.includes(label)))
      .map(p => ({...p,  labels: listDifference(p.labels, filteredLabels) }))

    await this.performerService.updatePerformers(performers)
    this.buildMenu()    
  }

  async removeLabels(_, event) { 
    removeLabelsFromMany(this.removeLabelsUpdateFunction.bind(this), this.performer_labels, this.dialog, 'performer', this.selectedPerformers, event)
  }

  async addLabels(_, event) { 
    addLabelsToMany(this.addLabelsUpdateFunction.bind(this), this.performer_labels, this.dialog, 'performer', this.selectedPerformers, event)
  }


  loadCondensed() {
    this.condensed = loadLocal(`${this.filterPage}:${toggleFilterTypes.condensed}`, false)
  }

  async deletePerformers(toDelete: PerformerTableData[], event) {
    const data: ConfirmDeleteData = {
      title: `Delete ${toDelete.length} performers`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to delete ${toDelete.length > 1 ? `all ${toDelete.length} selected performers` : 'the selected performer'}? The performer${toDelete.length > 1 ? 's' : ''} will also be removed from all sessions.`,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.performerService.deletePerformers(toDelete.map(({ performer }) => performer))
  }

  managePerformer({ performer }: PerformerTableData) {
    this.openPerformerManager(performer)
    // this.openPerformerEditor(performer)
  }

  async openPerformerManager(performer: Performer, autoFocus = false) {
    const data: ManagePerformerData = { performerId: performer.id, readOnly: !this.event || this.event.is_readonly }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManagePerformerComponent, { disableClose: true, autoFocus, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  addAPerformer(event: Event) {
    addAPerformer(event, this.dialog, this.performerService, this.openPerformerManager.bind(this))
  }

  async changePerformerType(toChange: PerformerTableData[], event) {
    const parent = event.target.parentElement
    const rect = parent.getBoundingClientRect()

    const position = { top: rect.bottom - 2, left: rect.left }
    const data: ChooseOrAddTypesData<PerformersService, Performer> = {
      position, 
      dialog: this.dialog, 
      entityService: this.performerService, 
      types: this.event.performerTypes,
      entities: toChange.map(({ performer }) => performer),
      single: false,
      typeName: 'Performer'
    }
    console.log(data)
    await chooseOrAddEntityTypes(data)
  }

  async duplicatePerformers(toDuplicate, event) { // not in use as multiple duplicates at one time can lead to crazy results
    const data: ConfirmDeleteData = {
      title: `Duplicate ${toDuplicate.length} performer${toDuplicate.length === 1 ? '' : 's'}`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to duplicate ${toDuplicate.length > 1 ? `all ${toDuplicate.length} selected performers` : 'the selected performer'}?`,
      dialog: this.dialog,
      deleteButtonText: 'DUPLICATE',
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.performerService.duplicatePerformers(toDuplicate.map(({ performer }) => performer))
  }


}
